module.exports = __webpack_public_path__ + "img/icon2.606784bf.png";